export default __webpack_public_path__ + "static/media/theme_egypten.3dc3b579.jpg";